export default __webpack_public_path__ + "enterprise-boundaries-xray-960-cf336427f1bd70583acd285ea83e6912.webp";